import React from "react";
import { VStack } from "@UI/Components/Stack/Stack";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { messages } from "./messages";
import { Flex } from "@UI/Components/Flex/Flex";
import { Text } from "@UI/Components/Text/Text";
import { Bold } from "@UI/Components/Bold/Bold";
import { CopyToClipboardIcon } from "@Shared/Components/CopyToClipboardIcon/CopyToClipboardIcon";
import { Money } from "@Shared/Components/Money/Money";
import { useMoney } from "@Shared/hooks/useMoney";
import { useCurrentUser } from "@modules/Authentication/hooks/useCurrentUser";
import { IAppCurrency } from "@App/types";
import useI18n from "@I18n/hooks/useI18n";

interface BankTransferInfoProps {
  amountCents: number;
  currency: IAppCurrency;
}

export const BankTransferInformations = ({
  amountCents,
  currency,
}: BankTransferInfoProps) => {
  const { money } = useMoney();
  const { currentUser } = useCurrentUser();
  const { formatMessage } = useI18n();

  return (
    <VStack spacing={2} alignItems="baseline">
      <Flex justifyContent="space-between" alignItems="center" w="full">
        <Text fontSize={{ base: "sm", md: "md" }} mb={0}>
          <FormattedMessage {...messages.beneficiary} />
        </Text>
        <Flex textAlign="right">
          <Bold fontSize={{ base: "sm", md: "md" }}>
            <FormattedMessage {...messages.statementDescriptor} />
          </Bold>
          <CopyToClipboardIcon
            text={formatMessage(messages.statementDescriptor)}
          />
        </Flex>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center" w="full">
        <Text fontSize={{ base: "sm", md: "md" }} mb={0}>
          <FormattedMessage {...messages.iban} />
        </Text>
        <Flex textAlign="right">
          <Bold fontSize={{ base: "sm", md: "md" }}>
            <FormattedMessage {...messages.ibanValue} />
          </Bold>
          <CopyToClipboardIcon text={formatMessage(messages.ibanValue)} />
        </Flex>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center" w="full">
        <Text fontSize={{ base: "sm", md: "md" }} mb={0}>
          <FormattedMessage {...messages.amount} />
        </Text>
        <Flex textAlign="right">
          <Bold fontSize={{ base: "sm", md: "md" }}>
            <Money cents={Number(amountCents)} currency={currency} />
          </Bold>
          <CopyToClipboardIcon
            text={formatMessage(messages.amountToPay, {
              amountToPay: money({
                cents: Number(amountCents),
                currency,
              }),
            })}
          />
        </Flex>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center" w="full">
        <Text fontSize={{ base: "sm", md: "md" }} mb={0}>
          <FormattedMessage {...messages.reference} />
        </Text>
        <Flex textAlign="right">
          <Bold fontSize={{ base: "sm", md: "md" }}>
            <FormattedMessage
              {...messages.bankCommunication}
              values={{
                userId: currentUser?.id,
              }}
            />
          </Bold>
          <CopyToClipboardIcon
            text={formatMessage(messages.bankCommunication, {
              userId: currentUser?.id,
            })}
          />
        </Flex>
      </Flex>
    </VStack>
  );
};
